import React from "react";
import { Row, Col } from "react-bootstrap";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

//Components
import CheckboxComponent from "../CustomUIComponents/CheckboxComponent/CheckboxComponent";

//Strings
import { Strings } from "../../resources/i18n/i18n";



const LoanTypeEligibilityConfiguration = (props) => {
    const loanTypeEligibiltyConfig = props.configurationData.configurationObject.configuration;

    const stylesTableCell = () => {
        return styled(TableCell)(({ theme }) => {
            return {
                [`&${tableCellClasses.head}`]: {
                    fontWeight: "bold",
                    backgroundColor: theme.palette.action.hover,
                    color: theme.palette.common.black,
                },
                [`&.${tableCellClasses.body}`]: {
                    fontSize: 14,
                },
            };
        });
    };

    const onCheckboxSelection = (loanTypeIndex, value, loanType, sectionKey) => {
        
        let loanDetails = loanTypeEligibiltyConfig[loanTypeIndex];
        let section = loanDetails[sectionKey];
        let grades = section || [];
        if (grades.includes(value)){
            grades = grades.filter(grade => grade !== value);
        } else {
            grades.push(value);
        }
        loanDetails[sectionKey] = grades;
        props.handleLoanTypeEligibilityConfigChange(loanTypeEligibiltyConfig);
    };

    const StyledTableCell = stylesTableCell();

    return (
        <div className='emiConfiguration'>
            {loanTypeEligibiltyConfig.map((loanTypeDetails, loanTypeIndex) => (
                <Row>
                    <Col md={12} className="pb-3">
                        <Accordion
                            defaultExpanded={loanTypeIndex === 0}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls='panel1a-content'
                                id='panel1a-header'
                                className='emiAccordianSummary'
                            >
                                <Typography component={"span"}>
                                    {Strings(loanTypeDetails.loanType)}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {Object.keys(loanTypeDetails).filter(key => key !== 'loanType').map((sectionKey, sectionKeyIndex) => (
                                    <Row key={sectionKey}>
                                        <Col md={12} className="pb-3">
                                            <TableContainer component={Paper}>
                                                <Table aria-label='customized table'>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>
                                                                <Typography component={"span"}>
                                                                    {Strings(sectionKey)}
                                                                </Typography>
                                                            </StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow key={sectionKeyIndex}>
                                                            <TableCell
                                                                component='th'
                                                                scope='row'
                                                            >
                                                                <Row>
                                                                    <Col md={12} className='px-0 py-1'>
                                                                        <Typography component={"span"}>
                                                                            {Strings("Grade")}
                                                                        </Typography>
                                                                    </Col>
                                                                    {['A', 'B', 'C', 'D'].map((grade, gradeIndex) => (
                                                                        <Col
                                                                            md={2}
                                                                            key={loanTypeDetails.loanType + loanTypeIndex + gradeIndex + grade}
                                                                        >
                                                                            <CheckboxComponent
                                                                                label={grade}
                                                                                checked={loanTypeDetails[sectionKey].includes(grade)}
                                                                                onChange={() => {
                                                                                    if (!props.readOnly) {
                                                                                        onCheckboxSelection(loanTypeIndex, grade, loanTypeDetails.loanType, sectionKey);
                                                                                    }
                                                                                }}
                                                                                disabled={props.readOnly}
                                                                                key={grade}
                                                                            />
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Col>
                                    </Row>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </Col>
                </Row>
            ))}
        </div>
    );
}

export default LoanTypeEligibilityConfiguration;